import React, { useContext, useEffect } from 'react'
import { AppStateContext } from '../AppStateContext'
import { FaTimes } from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import ExpandButton from '../../../elem/list/ExpandButton'

export default ({ setIsDetailMenuExpanded }) => {
    const { updateDetailState } = useContext(AppStateContext)
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    useEffect(() => {
        setIsDetailMenuExpanded(isExpanded)
    }, [isExpanded, setIsDetailMenuExpanded])

    return (
        <PanelHeader extraClass="wellDetailPanelHeader">
            <div className="panelHeaderText">Details</div>
            <div className="panelButtons">
                <ExpandButton
                    name={'detail'}
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                />
                <div
                    className="panelButton"
                    onClick={e => {
                        e.preventDefault()
                        updateDetailState('well', { visible: false })
                    }}
                >
                    <FaTimes />
                </div>
            </div>
        </PanelHeader>
    )
}
